<div
  class="upload-wrapper"
  [ngClass]="{
    'has-file': displayFilename,
    disabled: disabled
  }"
  [class]="theme"
>
  <label [for]="uniqueId">
    <studio-icon *ngIf="showIcon" name="upload" size="24"></studio-icon>

    <span class="inner-label">
      <ng-container *ngIf="displayFilename; else noFileName">{{ filename }}</ng-container>
      <ng-template #noFileName>{{ label }}</ng-template>
    </span>

    <input
      #fileInput
      [id]="uniqueId"
      type="file"
      [accept]="accept"
      multiple="false"
      [disabled]="disabled"
      (change)="fileSelected($event.target)"
    />
  </label>

  <button *ngIf="displayFilename" class="clear-file" (click)="clearFileClicked()">
    <studio-icon name="close" size="12"></studio-icon>
  </button>
</div>
